
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Pill',
    components: {},
    props: {
        text: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            default: '',
        },
    },
});
